const questions = [
  // 1 Слайд \\
  {
    questionDesc: [
      "Mũ bảo hiểm – một phần thiết yếu trong trang bị của tài xế. Mũ bảo hiểm từ Maxim vừa phong cách vừa bền chắc: được làm từ nhựa dày và có lớp lót mềm mại.",
    ],
    questionText: "Bạn nghĩ mũ bảo hiểm đã xuất hiện bao lâu rồi?",
    answerOptions: [
      {
        answerText: "30 năm",
        answerResult:
          "Chiếc mũ bảo hiểm đầu tiên được tạo ra vào năm 1914. Phiên bản đầu tiên được làm từ da và nút bần.",
        result: false,
      },
      {
        answerText: "50 năm",
        answerResult:
          "Chiếc mũ bảo hiểm đầu tiên được tạo ra vào năm 1914. Phiên bản đầu tiên được làm từ da và nút bần.",
        result: false,
      },
      {
        answerText: "70 năm",
        answerResult:
          "Chiếc mũ bảo hiểm đầu tiên được tạo ra vào năm 1914. Phiên bản đầu tiên được làm từ da và nút bần.",
        result: false,
      },
      {
        answerText: "100 năm",
        answerResult:
          "Chiếc mũ bảo hiểm đầu tiên được tạo ra vào năm 1914. Phiên bản đầu tiên được làm từ da và nút bần.",
        result: true,
      },
    ],
    image: "images/1.webp",
  },

  // 2 слайд \\
  {
    questionDesc: [
      "Những nhân vật mặc áo mưa màu vàng đã trở thành một phần của văn hóa đại chúng. Chúng ta thấy áo đó trên poster phim “It”, Coraline và Gấu Pooh cũng mặc áo mưa vàng. Áo mưa của chúng tôi cũng có màu vàng rực rỡ.",
    ],
    questionText: "Tại sao lại như vậy?",
    answerOptions: [
      {
        answerText:
          "Vì màu vàng là màu truyền thống của taxi trên toàn thế giới.",
        answerResult:
          "Áo mưa có thể có bất kỳ màu nào, điều này không ảnh hưởng đến tính năng của nó. Vì vậy chúng tôi đã chọn màu vàng làm màu nhận diện thương hiệu.",
        result: false,
      },
      {
        answerText: "Vì chỉ có vải màu vàng mới có khả năng chống nước.",
        answerResult:
          "Áo mưa có thể có bất kỳ màu nào, điều này không ảnh hưởng đến tính năng của nó. Vì vậy chúng tôi đã chọn màu vàng làm màu nhận diện thương hiệu.",
        result: false,
      },
      {
        answerText: "Vì màu vàng là màu nhận diện của dịch vụ đặt xe Maxim.",
        answerResult:
          "Áo mưa có thể có bất kỳ màu nào, điều này không ảnh hưởng đến tính năng của nó. Vì vậy chúng tôi đã chọn màu vàng làm màu nhận diện thương hiệu.",
        result: true,
      },
      {
        answerText:
          "Màu này đã chiến thắng trong cuộc bình chọn của cộng đồng.",
        answerResult:
          "Áo mưa có thể có bất kỳ màu nào, điều này không ảnh hưởng đến tính năng của nó. Vì vậy chúng tôi đã chọn màu vàng làm màu nhận diện thương hiệu.",
        result: false,
      },
    ],
    image: "images/2.webp",
  },

  // 3 слайд \\
  {
    questionDesc: [
      "Trong thế giới thời trang có hàng trăm loại áo khoác. Áo khoác thương hiệu Maxim được thiết kế riêng cho khách hàng và tài xế của dịch vụ. Nó nhẹ, chất lượng, tiện lợi và phong cách.",
    ],
    questionText:
      "Bạn nghĩ ai là người đầu tiên sử dụng áo khoác bomber và tại sao nó lại trở nên cần thiết?",
    answerOptions: [
      {
        answerText: "Dành cho người leo núi để tránh gió trên núi",
        answerResult:
          "Áo bomber dành cho phi công xuất hiện vào đầu thế kỷ XX. Áo được làm từ da và lông thú vì nhiệt độ trong buồng lái có thể xuống tới -50°C.",
        result: false,
      },
      {
        answerText: "Dành cho phi công để chống lại cái lạnh",
        answerResult:
          "Áo bomber dành cho phi công xuất hiện vào đầu thế kỷ XX. Áo được làm từ da và lông thú vì nhiệt độ trong buồng lái có thể xuống tới -50°C.",
        result: true,
      },
      {
        answerText: "Dành cho thủy thủ để vượt qua bão trên đại dương",
        answerResult:
          "Áo bomber dành cho phi công xuất hiện vào đầu thế kỷ XX. Áo được làm từ da và lông thú vì nhiệt độ trong buồng lái có thể xuống tới -50°C.",
        result: false,
      },
      {
        answerText: "Dành cho người đi xe đạp để có thể đi vào thời tiết lạnh",
        answerResult:
          "Áo bomber dành cho phi công xuất hiện vào đầu thế kỷ XX. Áo được làm từ da và lông thú vì nhiệt độ trong buồng lái có thể xuống tới -50°C.",
        result: false,
      },
    ],
    image: "images/3.webp",
  },

  // 4 слайд \\
  {
    questionDesc: [
      "Từ năm 2000, Viện Màu sắc Pantone chọn màu xu hướng mỗi năm. Màu đen tối giản là biểu tượng của phong cách và đó chính là màu của quần thương hiệu Maxim.",
    ],
    questionText:
      "Theo bạn, màu đen đã bao nhiêu lần được Pantone chọn là «màu của năm»?",
    answerOptions: [
      {
        answerText: "0 lần",
        answerResult:
          "Màu đen chưa từng được Pantone chọn là “màu của năm”, mặc dù hàng triệu người trên thế giới yêu thích màu này.",
        result: true,
      },
      {
        answerText: "1 lần",
        answerResult:
          "Màu đen chưa từng được Pantone chọn là “màu của năm”, mặc dù hàng triệu người trên thế giới yêu thích màu này.",
        result: false,
      },
      {
        answerText: "3 lần",
        answerResult:
          "Màu đen chưa từng được Pantone chọn là “màu của năm”, mặc dù hàng triệu người trên thế giới yêu thích màu này.",
        result: false,
      },
      {
        answerText: "5 lần",
        answerResult:
          "Màu đen chưa từng được Pantone chọn là “màu của năm”, mặc dù hàng triệu người trên thế giới yêu thích màu này.",
        result: false,
      },
    ],
    image: "images/4.webp",
  },

  // 5 слайд \\
  {
    questionDesc: [
      "Lịch sử của áo thun tay dài bắt đầu từ thế kỷ XIX. Trong suốt thời gian đó, chất liệu đã thay đổi, các phong cách mới được tạo ra. Ví dụ, áo tay dài thương hiệu Maxim được lấy cảm hứng từ đồng phục bóng đá.",
    ],
    questionText: "Hãy chọn một sự thật đúng về loại trang phục này:",
    answerOptions: [
      {
        answerText: "Ban đầu chỉ có nam giới mặc",
        answerResult:
          "Ban đầu, loại trang phục này được nam giới mặc như đồ lót. Mãi đến thế kỷ XX, áo thun tay dài mới trở thành một phần trong trang phục hằng ngày của phụ nữ.",
        result: true,
      },
      {
        answerText: "Trở nên nổi tiếng nhờ Coco Chanel",
        answerResult:
          "Ban đầu, loại trang phục này được nam giới mặc như đồ lót. Mãi đến thế kỷ XX, áo thun tay dài mới trở thành một phần trong trang phục hằng ngày của phụ nữ.",
        result: false,
      },
      {
        answerText: "Trước đây chỉ có màu trắng",
        answerResult:
          "Ban đầu, loại trang phục này được nam giới mặc như đồ lót. Mãi đến thế kỷ XX, áo thun tay dài mới trở thành một phần trong trang phục hằng ngày của phụ nữ.",
        result: false,
      },
      {
        answerText: "Chỉ được làm từ 100% cotton",
        answerResult:
          "Ban đầu, loại trang phục này được nam giới mặc như đồ lót. Mãi đến thế kỷ XX, áo thun tay dài mới trở thành một phần trong trang phục hằng ngày của phụ nữ.",
        result: false,
      },
    ],
    image: "images/5.webp",
  },
];

export default questions;
